import i18n from '@/i18n'
import { resolveI18nNavLabel } from '@/utils/navLabel'

let brandingCache = null
let currentPagePart = ''

export function setBrandingCache(branding) {
  brandingCache = branding || null
}

export function getSiteName(locale) {
  const loc = locale || i18n.locale
  if (brandingCache) {
    if (loc === 'en' && brandingCache.titleEn) return brandingCache.titleEn
    if (brandingCache.titleZh) return brandingCache.titleZh
    if (brandingCache.titleEn) return brandingCache.titleEn
  }
  return i18n.t('siteTitle')
}

export function formatDocumentTitle(pagePart, locale) {
  const site = getSiteName(locale)
  const part = String(pagePart || '').trim()
  if (!part || part === site) return site
  return part + ' - ' + site
}

export function setPageTitle(pagePart, locale) {
  currentPagePart = String(pagePart || '').trim()
  document.title = formatDocumentTitle(currentPagePart, locale || i18n.locale)
}

export function refreshPageTitle(locale) {
  document.title = formatDocumentTitle(currentPagePart, locale || i18n.locale)
}

function localeMessages(locale) {
  const loc = locale || i18n.locale
  return (i18n.messages && i18n.messages[loc]) || i18n.messages[i18n.locale] || {}
}

export function resolveRouteTitle(route, locale) {
  const loc = locale || i18n.locale
  const messages = localeMessages(loc)
  const meta = route.meta || {}
  const params = route.params || {}
  const name = route.name

  if (meta.titleKey) {
    return i18n.t(meta.titleKey)
  }

  switch (name) {
    case 'Home':
      return ''
    case 'ProductCenter':
      return i18n.t('nav.products')
    case 'ProductCategory':
      return resolveI18nNavLabel(messages, 'productNav', params.categorySlug, i18n.t('nav.products'))
    case 'ProductDetail':
      return resolveI18nNavLabel(messages, 'productNav', params.categorySlug, i18n.t('nav.products'))
    case 'NewsAll':
      return i18n.t('nav.news')
    case 'NewsCategory':
      return resolveI18nNavLabel(messages, 'newsNav', params.newsSlug, i18n.t('nav.news'))
    case 'NewsDetail':
      return resolveI18nNavLabel(messages, 'newsNav', params.newsSlug, i18n.t('nav.news'))
    case 'About':
      return i18n.t('nav.about')
    case 'Contact':
      return i18n.t('contact.pageTitle')
    case 'Search':
      return i18n.t('search.title')
    case 'Case':
    case 'CaseSub':
      return resolveI18nNavLabel(messages, 'applicationNav', params.solutionSlug, i18n.t('nav.applications'))
    case 'CaseDetail':
      return resolveI18nNavLabel(messages, 'applicationNav', params.solutionSlug, i18n.t('nav.applications'))
    default:
      if (name && String(name).indexOf('Service_') === 0) {
        const slug = String(name).slice('Service_'.length)
        return resolveI18nNavLabel(messages, 'serviceNav', slug, i18n.t('nav.services'))
      }
      return ''
  }
}

export function setupPageTitleGuard(router) {
  router.afterEach(to => {
    setPageTitle(resolveRouteTitle(to))
  })
}
